module.exports = __webpack_public_path__ + "img/y18.4fd8d13a.jpg";